import Cross from "./SVG/cross.svg?react";

const CrossIcon = () => {
  return <Cross />;
};

export default CrossIcon;
